import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography, Chip} from 'views/components';
import {Translate} from 'views/module';

const YourCareBoxView = (props) => {
  const {data} = props;

  let langs = [];
  if (typeof data.languages === 'string') {
    langs = data.languages
        .split(/[,\s]+/)
        .map((l) => l.trim())
        .filter((l) => l);
  } else if (Array.isArray(data.languages)) {
    langs = data.languages;
  }

  return (
    <Box style={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.YourCareBox.YourCare" />
        </Typography>
      </Box>

      <Box sx={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', alignItems: 'start'}}>
        {/* Top Left: Name */}
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
          <Typography variant="subtitle2">
            <Translate expression="profile.YourCareBox.CareRecipientName" />
          </Typography>
          {
            data.name && (
              <Typography>{data.name}</Typography>
            )}
          {
            !data.name && (
              <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem'}}>
                <Translate expression="profile.YourCareBox.NamePlaceholder" />
              </Typography>
            )
          }
        </Box>

        {/* Top Right: Location */}
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
          <Typography variant="subtitle2">
            <Translate expression="profile.YourCareBox.Location" />
          </Typography>
          {
            data.location && (
              <Typography>{data.location}</Typography>
            )
          }
          {
            !data.location && (
              <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem'}}>
                <Translate expression="profile.YourCareBox.LocationPlaceholder" />
              </Typography>
            )
          }
        </Box>

        {/* Bottom Left: Languages */}
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
          <Typography variant="subtitle2">
            <Translate expression="profile.YourCareBox.LanguagesSpoken" />
          </Typography>
          {
            langs.length > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  gap: '0.5rem',
                  marginTop: '0.25rem',
                  color: '#5b8ecb',
                  flexWrap: 'wrap',
                  alignItems: 'flex-start',
                  minHeight: 32,
                }}
              >
                {langs.map((lang, idx) => (
                  <Chip key={idx} label={lang} size="small" style={{color: '#3060d9', background: '#e6f0fa', marginBottom: 4}} />
                ))}
              </Box>
            )
          }
          {
            langs.length === 0 && (
              <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem'}}>
                <Translate expression="profile.YourCareBox.LanguagesPlaceholder" />
              </Typography>
            )
          }
        </Box>

        {/* Bottom Right: Start Date */}
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
          <Typography variant="subtitle2">
            <Translate expression="profile.YourCareBox.StartDate" />
          </Typography>
          {
            data.startDate && (
              <Typography>{data.startDate}</Typography>
            )}
          {
            !data.startDate && (
              <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem'}}>
                <Translate expression="profile.YourCareBox.StartDatePlaceholder" />
              </Typography>
            )
          }
        </Box>
      </Box>
    </Box>
  );
};

YourCareBoxView.propTypes = {
  data: PropTypes.object.isRequired,
};

export default YourCareBoxView;
